/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { Component, Input } from '@angular/core';
import { ErrorResponseModel } from '../../../../../core/models';
import { LicenceApiService } from '../../http';
import { LicenceModel, UpdateModel } from '../../models';
import { LogService, UtilsService } from '../../../../../core/services';
import { UpdatesService } from '../../services';
import { WidgetBaseComponent } from '../widgetBase.component';
import { WidgetInterface } from '../../interfaces/widget.interface';
import { WidgetStateEnum } from '../../../../../core/enums';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-lb-widget-license-details',
    templateUrl: './licenseDetails.widget.html',
    styleUrls: ['./licenseDetails.widget.scss']
})

export class LicenseDetailsWidgetComponent extends WidgetBaseComponent implements WidgetInterface {
    /**
     * Input for the hide content.
     */
    @Input() public hideContent: any;

    /**
     * The license object used to show details on the widget.
     */
    public license: LicenceModel;

    /**
     *  Define our updates model.
     */
    public updates: UpdateModel;

    /**
     * Loading variable.
     */
    public loading: any = {
        licenseDetails: false,
        updatesStatus: false,
        status: function () {
            return this.FloatingIps && this.UpdatesStatus;
        }
    };

    /**
     * Set our default state.
     */
    public state: WidgetStateEnum;

    constructor(
        private licenseAPI: LicenceApiService,
        private logService: LogService,
        private updatesService: UpdatesService,
        utils: UtilsService
    ) {
        super(utils);

        this.resetLocalVariables();
        this.getWidgetDetails();
    }

    /**
     * Get the licence details.
     */
    public getWidgetDetails(): void {
        this.licenseAPI.getLicenceDetails()
            .pipe(takeUntil(this.destroyed$))
            .subscribe({
                next: (license: LicenceModel) => {
                    this.license = license;
                    this.loading.licenseDetails = true;
                },
                error: (error: ErrorResponseModel): void => {
                    this.logService.error(
                        'LicenseDetailsWidgetComponent:getWidgetDetails', 'Unable to get Licence Details. ' + error.message
                    );
                }
            });

        this.updates = this.updatesService.getUpdates();
        this.loading.updatesStatus = true;
    }

    /**
     * Reset the local variables.
     */
    public resetLocalVariables(): void {
        this.license = <LicenceModel>{};
        this.state = WidgetStateEnum.OK;
    }
}
